import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'console';
import { forkJoin } from 'rxjs';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
import { allCountriesList } from 'src/app/shared/countryList';
@Component({
  selector: 'app-prohibited-items',
  templateUrl: './prohibited-items.component.html',
  styleUrls: ['./prohibited-items.component.css']
})
export class ProhibitedItemsComponent implements OnInit {


  showInitialData: boolean = true;
  countriesList: any[] = allCountriesList;

  prohibitedItemsData: any;

  selectedCountryName: string = "";
  selectedCountryCode: string = "";
  selectedCountry = "";
  selectedItemHTML = "";


  allCountriesData: any[] = [];
  currentCountryName: string = "";

  constructor(
    public http: HttpClient,
    public signUpService: SignupService,
    private watcherService: WatcherService,
    private _route: ActivatedRoute,
    private _router: Router, 
  ) {



    const getAllCountryObs = this.signUpService.getAllCountries();
    const getAllProhibitedItemsObs = this.signUpService.getAllProhibitedItemsLists();
    this._route.params.subscribe(params => {
      this.currentCountryName = params['countryName'];

    })


    forkJoin([
      getAllCountryObs,
      getAllProhibitedItemsObs
    ]).subscribe(
      ([allCountryResponse, allProhibitedResponse]) => {
        this.allCountriesData = allCountryResponse["data"];
        let prohibitedDataList = allProhibitedResponse['data'];
        let activeProhibitedListArr = prohibitedDataList.filter(prohibitedEl => prohibitedEl.is_active === 1);
        let activeProhibitedList = new Set();
        activeProhibitedListArr.forEach(prohibitedEl => {
          activeProhibitedList.add(prohibitedEl.country);
        })
        this.prohibitedCountriesActiveList = this.allCountriesData.filter((country) => activeProhibitedList.has(country.code));
      })
  }
  lang;

  prohibitedCountriesActiveList: any[] = [];
  ngOnInit(): void {


    this._route.params.subscribe(params => {
      this.selectedCountryName = params['countryName'];

      this.signUpService.getAllCountries().subscribe({
        next: getAllCountries => {


          if (this.selectedCountryName && (this.selectedCountryName.toLowerCase() === 'united-states' || this.selectedCountryName.toLowerCase() == 'united-states-of-america')) {
            this.selectedCountryCode = 'US';
            this.signUpService.getProhibitedItemsViaCountry(this.selectedCountryCode).subscribe(data => {
              this.prohibitedItemsData = data['data'];
              if (this.prohibitedItemsData.is_active === 1) {
                this.showInitialData = false;
                this.selectedCountry = 'US';
              }
            })
          } else {
            const allCountries = getAllCountries['data'];
            allCountries.find(country => {
              if(this.selectedCountryName){
                if (country['name'].replace(/\s/g, "-").toLowerCase() === this.selectedCountryName.toLowerCase()) {
                  this.selectedCountry = country.code;
                  return this.selectedCountryCode = country.code;
                }
              }
            })
            this.signUpService.getProhibitedItemsViaCountry(this.selectedCountryCode).subscribe(data => {
              this.prohibitedItemsData = data['data'];
              if (this.prohibitedItemsData.is_active === 1) {
                this.showInitialData = false;
               
              }
              
            })
          }
        },
        error: err => {
        }
      })




    })
    this.watcherService.getLang().subscribe(
      lang => {
        this.lang = lang;
      }
    )
  }
  changeCountry(countryURL) {
    this.getProhibitedItems(countryURL)


  }

  getProhibitedItems(countryCode) {
    let countryName: string;
    const selectedCountryN = this.prohibitedCountriesActiveList.find(country => country.code === countryCode);
    if (selectedCountryN) {
      countryName = selectedCountryN.name.replace(/\s/g, "-").toLowerCase();
      this._router.navigate(['/', this.lang, 'prohibited-items', countryName]);
    } else {
      return;
    }
  }
}